<template>
  <div>
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">ایجاد تیکت</h4>
        <hr />
      </template>
      <template v-slot:content>
        <form id="CreateTilcket">

          <!-- دپارتمان -->
          <div class="row">
            <div class="col-md-2 col-12"></div>
            <div class="col-md-8 col-12 text-center">
              <label v-for="(list, index) in depList" :key="list.id" class="lblradio">
                <div v-if="isCustomer">
                  <div v-if="list.customerSee">
                    <input type="radio" name="product" class="card-input-element required" id="rdoDep"
                      @click="depSelect(list, index)" v-if="index == 0" checked />

                    <input type="radio" name="product" class="card-input-element required" id="rdoDep"
                      @click="depSelect(list, index)" v-else />

                    <div class="card card-input">
                      <div class="card-header text-right">
                        <i v-if="index == selctesdDep" class="fas fa-check-circle" aria-hidden="true"></i>
                      </div>
                      <div class="card-body text-center">
                        <div class="dep-Icon">
                          <i :class="list.icon == null ? 'fad fa-users-class' : list.icon" aria-hidden="true"></i>
                        </div>
                        <span class="text-secondary">
                          {{ list.name }}
                        </span>
                      </div>
                    </div>
                  </div>

                </div>

                <div v-if="!isCustomer">
                  <input type="radio" name="product" class="card-input-element required" id="rdoDep"
                    @click="depSelect(list, index)" v-if="index == 0" checked />

                  <input type="radio" name="product" class="card-input-element required" id="rdoDep"
                    @click="depSelect(list, index)" v-else />

                  <div class="card card-input">
                    <div class="card-header text-right">
                      <i v-if="index == selctesdDep" class="fas fa-check-circle" aria-hidden="true"></i>
                    </div>
                    <div class="card-body text-center">
                      <div class="dep-Icon">
                        <i :class="list.icon == null ? 'fad fa-users-class' : list.icon" aria-hidden="true"></i>
                      </div>
                      <span class="text-secondary">
                        {{ list.name }}
                      </span>
                    </div>
                  </div>
                </div>

              </label>
            </div>
            <div class="col-md-2 col-12"></div>
          </div>

          <!-- ایجاد تیکت مشتری -->
          <div v-if="$session.get('CustomerInfo') != undefined && $session.get('CustomerInfo').Id > 0">
            <div class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12 text-center">
                <div class="mt-3">
                  <small id="LblTitle">موضوع تیکت</small>
                  <input @keypress="$ValidLenght($event, 150)" id="txtSubject" type="text" v-model="request.Title"
                    class="form-control required mt-1 text-center" autocomplete="off" />
                </div>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
            <div class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-4 col-12">
                <small id="LblTblCostomer">مربوط به مشتری</small>
                <SearchableCombo v-if="$session.get('CustomerInfo') != undefined && $session.get('CustomerInfo').Id > 0"
                  :edit="false" :grp="0" :code="null" @ResultCombo="GetResulTblCostomer" :rownumintable="3"
                  :defaultvalue="$session.get('CustomerInfo').Id"
                  :action="'TblCrmCombo/GetCostomerId/' + $session.get('CustomerInfo').Id" :method="'POST'"
                  :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false" :ClassProps="'required'">
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12">
                <small id="LbltblComboGrpId42">اهمیت</small>
                <SearchableCombo :edit="false" :grp="42" :code="null" :rownumintable="3"
                  @ResultCombo="GetResulTicketLevel" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                  :idinput="'TicketLevel'" :keyItem="'TicketLevel'" :defaultvalue="1800" :disabled="false">
                </SearchableCombo>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
            <div class="row mt-3">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <small id="LblTblCostomer"> نوع تیکت </small>
                <SearchableCombo :edit="false" :grp="45" :code="null" @ResultCombo="GetResultGrp45" :rownumintable="3"
                  :defaultvalue="request.tblComboGrpId45" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                  :idinput="'Grp45Id'" :keyItem="'Grp45Id'" :ClassProps="'required'">
                </SearchableCombo>
              </div>
              <!-- <div class="col-md-4 col-12">
                <small id="LblTblCostomer">فرم</small>
                <select  class="form-control col-12" disabled></select>
              </div> -->
              <div class="col-md-2 col-12"></div>
            </div>
            <div class="row mt-2">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <small id="LblDescription">توضیحات</small>
                <textarea type="text" class="form-control InputText required" rows="5"
                  v-model="request.Description"> </textarea>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
          </div>

          <!-- ایجاد تیکت پشتیبان -->
          <div v-else>
            <div class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12 text-center">
                <div class="mt-3">
                  <small id="LblTitle">موضوع تیکت</small>
                  <input @keypress="$ValidLenght($event, 150)" id="txtSubject" type="text" v-model="request.Title"
                    class="form-control required mt-1 text-center" autocomplete="off" />
                </div>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
            <div class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-4 col-12">
                <small id="LblTblCostomer">مربوط به مشتری</small>
                <SearchableCombo v-if="$session.get('CustomerInfo') != undefined && $session.get('CustomerInfo').Id > 0"
                  :edit="false" :grp="0" :code="null" @ResultCombo="GetResulTblCostomer" :rownumintable="3"
                  :defaultvalue="$session.get('CustomerInfo').Id"
                  :action="'TblCrmCombo/GetCostomerId/' + $session.get('CustomerInfo').Id" :method="'POST'"
                  :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false" :ClassProps="'required'">
                </SearchableCombo>
                <SearchableCombo v-else :edit="false" :grp="0" :code="null" @ResultCombo="GetResulTblCostomer"
                  :rownumintable="3" :defaultvalue="request.tblCustomerId" :action="'TblCrmCombo/GetCostomerProduct'"
                  :method="'POST'" :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false"
                  :ClassProps="'required'">
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12">
                <small id="LbltblComboGrpId42">اهمیت</small>
                <SearchableCombo :edit="false" :grp="42" :code="null" :rownumintable="3"
                  @ResultCombo="GetResulTicketLevel" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                  :idinput="'TicketLevel'" :keyItem="'TicketLevel'" :defaultvalue="1800" :disabled="false">
                </SearchableCombo>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
            <div v-if="$session.get('CustomerInfo') == undefined & showComboUser" class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-4 col-12">
                <small id="LblTblCostomer"> ارجاع به </small>
                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3"
                  :defaultvalue="request.tblUserId" :action="'Department/GetUserDepartment/' + request.tblDepartmentId"
                  :method="'GET'" :idinput="'UserId'" :keyItem="'UserId'">
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12">
                <small id="LblTblCostomer"> نوع تیکت </small>
                <SearchableCombo :edit="false" :grp="45" :code="null" @ResultCombo="GetResultGrp45" :rownumintable="3"
                  :defaultvalue="request.tblComboGrpId45" :action="'TblCrmCombo/GetComboById'" :method="'POST'"
                  :idinput="'Grp45Id'" :keyItem="'Grp45Id'" :ClassProps="'required'">
                </SearchableCombo>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
            <div class="row mt-2">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <small id="LblDescription">توضیحات</small>
                <textarea type="text" class="form-control InputText required" rows="5"
                  v-model="request.Description"> </textarea>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
          </div>

          <!-- فایل پیوست -->
          <div class="row mt-2">
            <div class="col-md-2 col-12"></div>
            <!-- <div class="col-md-6 col-12"></div>  -->

            <div class="col-md-6 col-12">
              <div v-if="uploadImageName != ''" class="imageName d-flex p-3">
                <div class="col-1 text-left">
                  <i @click="cancelUpload()" class="fas fa-times hover-danger"></i>
                </div>

                <div class="text-secondary font-weight-bold col-11 text-right">
                  {{ uploadImageName }} - {{ imageSize }} Kb &nbsp;&nbsp;&nbsp;
                  <i class="fad fa-upload text-secondary"></i>
                </div>
              </div>
            </div>

            <div class="col-md-2 col-12 text-left">
              <label class="atachticket" for="inputImage">
                <a class="badge">
                  ارسـال پـیـوسـت
                  <i class="fad fa-paperclip h4"
                    title="jpg, gif, jpeg, png, pdf, bmp, txt , zip , rar حداکثر 10 مگابایت"></i>
                </a>
                <input type="file" id="inputImage" style="display: none" name="image" :accept="acceptFile" multiple=""
                  data-original-title="upload photos" @change="uploadImage()" />
              </label>
            </div>

            <div class="col-md-2 col-12"></div>
          </div>
          <div class="row mt-4">
            <div class="col-md-2 col-12"></div>
            <div class="col-md-8 col-12">
              <button class="btn btn-success w-100 p-3" @click.prevent="submitTicket" v-if="!isSendingTicket">
                ثـبـت تـیکــت
                <i class="fad fa-envelope"></i>
              </button>

              <div class="btn w-100 p-3" v-if="isSendingTicket" style="cursor: default">
                <b-spinner label="Spinning"></b-spinner>
              </div>
            </div>
            <div class="col-md-2 col-12"></div>
          </div>
        </form>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import appsetting from '../../../../public/appSetting'
import JSZip from 'jszip'

export default {
  components: { Card, BnpGrid, SearchableCombo },
  data() {
    return {
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      isSendingTicket: false,
      acceptFile: ['.jpg', '.gif', '.jpeg', '.png', '.pdf', '.bmp', '.txt', '.zip', '.rar'],
      depList: [],
      imageSize: 0,
      fileFormat: '',
      isImage: null,
      uploadImageName: '',
      url: appsetting.ApiUrl,
      userId: this.$session.get('UserInfo').tblUserId,
      base64: null,
      DataAxios: {},
      request: {
        Title: '',
        Description: '',
        tblDepartmentId: '',
        TblCustomerId: '',
        tblComboGrpId42: '',
        tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        tblUserId: '',
        tblComboGrpId45: 1048322,
      },
      connection: null,
      selctesdDep: null,
      isCustomer: this.$session.get('CustomerInfo') != undefined && this.$session.get('CustomerInfo').Id > 0 ? true : false,
      ticketHubConnected: false,
      manualStopHub: false,
      ticketInterval: null,
      ticketConnection: null,
      showComboUser: false
    }
  },

  methods: {
    async ticketHub() {
      this.$GetSignalR().then((res) => {
        this.ticketConnection = res
        res.onclose(() => {
          if (!this.manualStopHub) {
            this.$swal.fire({
              position: "top-end",
              icon: "error",
              title: "اتصال شما با سرور قطع شد صفحه را رفرش نمایید",
              showConfirmButton: false,
              timer: 15000,
            });
          }
        })

        res.on("IdNewTicket", (idNewTicket, chatRoomId) => {

          setTimeout(() => {
            this.$router.push({
              name: 'ChatRoom',
              params: {
                ticketId: idNewTicket,
                chatRoomId: chatRoomId
              },
            })
          }, 120);

          // if(!this.isCustomer){
          //   let message = 'تیکت با شماره ' + idNewTicket + ' ثبت شد'
          //   this.$swal.fire({
          //     toast: false,
          //     title: '',
          //     text: message,
          //     icon: 'success',
          //     position: 'center',
          //     timer: 10000,
          //     showConfirmButton: true,
          //     showCancelButton:false,
          //     showCancelButton: false,
          //     timerProgressBar: true,
          //     confirmButtonText:'متوجه شدم'
          //   })
          //   // this.$mySweetDefaultTost('عملیات موفق', message, 'success', 10000)
          //   setTimeout(() => {
          //     this.$router.push({
          //       name: 'Tickets',
          //     })

          //   }, 120);



          // }
        })

      }).catch((error) => {
        this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در ایجاد اتصال تیکت', 'error', 4000)
        console.error('CATCH', error)
      })
    },

    tryConnect() {
      if (!this.ticketHubConnected) {
        if (!this.manualStopHub) {
          this.ticketHub().then(() => {
            this.ticketHubConnected = true
            clearInterval(this.ticketInterval)
          })
        }
      }
    },
    GetResulUserId(data) {
      if (data.id != null) {
        this.request.tblUserId = data.id
      }
    },
    GetResultGrp45(data) {
      if (data.id != null) {
        this.request.tblComboGrpId45 = data.id
      }
    },
    depSelect(row, index) {
      this.selctesdDep = index
      this.request.tblDepartmentId = row.id

      this.showComboUser = false
      this.$nextTick(() => {
        this.showComboUser = true
      })

      document.getElementById('txtSubject').focus()
    },

    async uploadImage() {
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      var input = document.getElementById('inputImage')
      if (input.files.length <= 5) {
        if (input.files.length > 1) {
          let filedata = null
          let zip = new JSZip()
          this.imageSize = 0
          this.uploadImageName = ''
          for (let index = 0; index < input.files.length; index++) {
            let lengthSplit = input.files[index].name.split('.').length
            var Checktypes = '.' + input.files[index].name.split('.')[lengthSplit - 1].toLowerCase()
            if (this.acceptFile.includes(Checktypes)) {
              this.imageSize += input.files[index].size
              this.uploadImageName += input.files[index].name + ' , '
              const element = input.files[index]
              let filename = input.files[index].name
              var folderName = this.$store.state.JalaliDate
              folderName = folderName.replaceAll('/', '_')
              zip.file(folderName + '/' + filename, element)
            } else {
              let Validformats = 'فرمت های معتبر' + '\n'
              this.acceptFile.forEach(element => {
                element = element.split('.')
                Validformats += element[1] + ', '
              });
              this.$mySweetDefaultTost('فرمت فایل نامعتبر', Validformats, 'info', 6000)
              this.cancelUpload()
              return
            }
          }
          this.imageSize = Math.round(this.imageSize / 1000)
          if (this.imageSize < 10010) {
            await zip
              .generateAsync({ type: 'base64' })
              .then(function (Convertbase64) {
                filedata = 'data:application/zip;base64,' + Convertbase64
              })
              .finally(() => {
                this.base64 = filedata
                this.base64 = this.base64.split(',')[1]
                this.isImage = false
                this.fileFormat = 'zip'
              })
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مجموع حجم فایل ها باید کمتر از 10 مگابایت باشد', 'info', 3000)
            this.cancelUpload()
          }
        } else {
          let lengthSplit = input.files[0].name.split('.').length
          var Checktype = '.' + input.files[0].name.split('.')[lengthSplit - 1].toLowerCase()
          if (this.acceptFile.includes(Checktype)) {
            var image = input.files[0]

            var imageType = image.type.split('/')[0]
            var imageName = image.name.split('.')
            var imageNameLength = imageName.length
            this.fileFormat = imageName[imageNameLength - 1]

            this.imageSize = Math.round(image.size / 1000)

            if (this.imageSize < 10010) {
              this.uploadImageName = image.name
              this.base64 = await toBase64(image)
              this.base64 = this.base64.split(',')[1]

              if (imageType == 'image') {
                this.isImage = true
              } else {
                this.isImage = false
              }
            } else {
              this.$mySweetDefaultTost('عملیات ناموفق', 'حجم فایل باید کمتر از 10 مگابایت باشد', 'info', 2500)
              this.cancelUpload()
            }
          } else {
            let Validformats = 'فرمت های معتبر' + '\n'
            this.acceptFile.forEach(element => {
              element = element.split('.')
              Validformats += element[1] + ', '
            });
            this.$mySweetDefaultTost('فرمت فایل نامعتبر', Validformats, 'info', 6000)
            this.cancelUpload()
          }
        }
      } else {
        this.$mySweetDefaultTost('عملیات ناموفق', 'حداکثر تعداد فایل انتخابی 5 عدد است', 'info', 2500)
      }
    },

    cancelUpload() {
      this.base64 = null
      this.uploadImageName = ''
      this.imageSize = 0
      var input = document.getElementById('inputImage')
      input.value = ''
      this.fileFormat = ''
      this.isImage = null
    },

    GetResulTblCostomer(data) {
      if (data.id != null) {
        this.request.TblCustomerId = data.id
      }
    },
    submitTicket() {
      if (this.request.tblDepartmentId == '') {
        this.$mySweetDefaultTost('عملیات ناموفق', 'انتخاب بخش برای تیکت اجباری است', 'error', 3000)
      } else {
        if (this.$ValidForm('CreateTilcket')) {
          this.isSendingTicket = true
          this.ticketConnection
            .invoke(
              'CreateTicket',
              this.request.Title,
              this.request.Description,
              String(this.request.tblDepartmentId),
              String(this.request.TblCustomerId),
              String(this.request.tblComboGrpId42),
              String(this.request.tblUserGrpIdInsert),
              String(this.request.tblUserId),
              this.base64,
              this.fileFormat,
              String(this.isImage),
              String(this.request.tblComboGrpId45)
            ).then((res) => {
              this.request.Title = ''
              this.request.Description = ''
              this.cancelUpload()

              this.isSendingTicket = false

            })
            .catch((error) => {
              this.$mySweetDefaultTost('عملیات ناموفق', 'فیلد های ورودی را کنترل نمایید', 'error', 3000)
              console.error('CATCH', error)
              this.isSendingTicket = false
              // this.cancelUpload()
            })
        }
      }
    },
    GetResulTicketLevel(data) {
      if (data.id != null) {
        this.request.tblComboGrpId42 = data.id
      }
    },
    GetResultDepartmentId(data) {
      if (data.id != null) {
        this.request.tblDepartmentId = data.id
      }
    },
  },
  mounted() {
    this.DataAxios_GetData.Action = 'Department/GetDepartments'
    this.DataAxios_GetData.Method = 'POST'
    this.$PostData(this.DataAxios_GetData).then((data) => {
      if (data.status != 'Not Ok') {
        if (this.isCustomer) {
          this.depList = data.filter(x => x.customerSee)
        } else {
          this.depList = data
        }
        var record = this.depList.find((element, index) => index == 0)
        this.depSelect(record, 0)
      }
    })
    this.ticketHub()
  },

  beforeDestroy() {
    this.manualStopHub = true
    this.ticketConnection.stop().then(() => {
      this.manualStopHub = true
      clearInterval(this.ticketInterval)
    })
  }
}
</script>

<style scoped>
textarea {
  resize: none;
}

.lblradio {
  transition: transform 250ms;
}

.lblradio:hover {
  transform: translateY(-10px);
}

.card-input-element {
  display: none;
}

.card-input {
  margin: 5px;
  padding: 0px;
  background: var(--sidebar-action-bg);
  /* color: var(--logo-color); */
}

.card-input:hover {
  cursor: pointer;
  opacity: 1;
  box-shadow: 0 4px 20px -5px var(--sidebar-action-bg);
  background: var(--sidebar-action-bg);
  color: var(--logo-color);
  transition: 0.3s;
}

.card-input-element:checked+.card-input {
  opacity: 1;
  box-shadow: 0 4px 20px -5px var(--sidebar-action-bg);
  background: var(--sidebar-action-bg);
  color: var(--logo-color);
}

.dep-Icon {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  font-size: 50px;
  padding: 2%;
  text-align: center;
}

.dep-Icon:hover {
  color: var(--logo-color);
}

.card-header {
  padding: 0.25rem 1.1rem;
  margin-bottom: 0;
  background-color: transparent !important;
  border: none !important;
}

.atachticket {
  box-shadow: 0 4px 20px -5px var(--sidebar-action-bg);
  background: var(--sidebar-action-bg);
  padding: 5px;
}

.badge:hover {
  color: var(--logo-color);
}

.imageName {
  border-radius: 5px;
  overflow: hidden;
  /* background: var(--sidebar-bg-color); */
  background: rgb(209, 208, 212);
  width: 100%;

  direction: ltr;
}
</style>
